/** Pull a real https URL out of journal label wrappers and malformed CSV values. */
export function extractConferenceUrl(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const text = String(raw).trim();
  if (!text) return null;

  // Prefer an explicit URL in parentheses: "Journal Title (https://…)"
  const inParens = text.match(/\(\s*(https?:?\/\/[^\s)]+)\s*\)/i);
  if (inParens?.[1]) {
    let url = inParens[1].replace(/^https\/\//i, 'https://');
    if (!/^https?:\/\//i.test(url)) url = `https://${url.replace(/^\/+/, '')}`;
    return url.replace(/[).,;]+$/, '');
  }

  // Any bare http(s) URL in the cell (doi.org, iaslc.org, conference sites, …)
  const loose = text.match(/https?:?\/\/[^\s)<>"]+/i);
  if (loose?.[0]) {
    return loose[0].replace(/^https\/\//i, 'https://').replace(/[).,;]+$/, '');
  }

  // www. host without scheme
  const www = text.match(/\bwww\.[^\s)<>"]+/i);
  if (www?.[0]) {
    return `https://${www[0].replace(/[).,;]+$/, '')}`;
  }

  if (/^https?:\/\//i.test(text)) {
    return text.split(/\s/)[0].replace(/[).,;]+$/, '');
  }

  return null;
}

export function conferenceUrlLabel(raw: string | null | undefined, fallback = 'Open link'): string {
  const url = extractConferenceUrl(raw);
  if (!url) return fallback;
  const m = url.match(/doi\.org\/(.+)$/i);
  if (m?.[1]) {
    const path = m[1];
    return path.length > 48 ? `doi.org/${path.slice(0, 45)}…` : `doi.org/${path}`;
  }
  try {
    return new URL(url).hostname;
  } catch {
    return fallback;
  }
}
